module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "partner-form"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2",
    staticStyle: {
      "padding": "50px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "postForm",
    attrs: {
      "id": "postForm",
      "model": _vm.postForm,
      "rules": _vm.rules
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.p__errors.hname,
      "label": "Hotel Name",
      "prop": "hname"
    }
  }, [_c('el-input', {
    staticClass: "article-textarea",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.postForm.hname),
      callback: function($$v) {
        _vm.$set(_vm.postForm, "hname", $$v)
      },
      expression: "postForm.hname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.p__errors.fname,
      "label": "First Name",
      "prop": "fname"
    }
  }, [_c('el-input', {
    staticClass: "article-textarea",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.postForm.fname),
      callback: function($$v) {
        _vm.$set(_vm.postForm, "fname", $$v)
      },
      expression: "postForm.fname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.p__errors.lname,
      "label": "Last Name",
      "prop": "lname"
    }
  }, [_c('el-input', {
    staticClass: "article-textarea",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.postForm.lname),
      callback: function($$v) {
        _vm.$set(_vm.postForm, "lname", $$v)
      },
      expression: "postForm.lname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.p__errors.title,
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "article-textarea",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.postForm.title),
      callback: function($$v) {
        _vm.$set(_vm.postForm, "title", $$v)
      },
      expression: "postForm.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.p__errors.email,
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    staticClass: "article-textarea",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.postForm.email),
      callback: function($$v) {
        _vm.$set(_vm.postForm, "email", $$v)
      },
      expression: "postForm.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.p__errors.info,
      "label": "Additional Information",
      "prop": "info"
    }
  }, [_c('el-input', {
    staticClass: "article-textarea",
    attrs: {
      "type": "textarea",
      "rows": 10
    },
    model: {
      value: (_vm.postForm.info),
      callback: function($$v) {
        _vm.$set(_vm.postForm, "info", $$v)
      },
      expression: "postForm.info"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', [_vm._v("Hotel Partner Equiry")]), _vm._v(" "), _c('p', [_vm._v("Questions? Feedback? We want to hear from you! Email us at info@opencabana.com or fill out the below form and we will get back to you within 24 hours.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08e5e54d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/hotel_partner/index.vue
// module id = 588
// module chunks = 2